export default "__VITE_ASSET__CevSP6e3__"